/* src/app/modules/concept/concept-tabs.component.scss */
/*# sourceMappingURL=concept-tabs.component.css.map */
